import React from 'react';

const Button = ({ 
  children, 
  variant = 'primary', 
  size = 'md', 
  icon: Icon, 
  className = '', 
  disabled = false,
  loading = false,
  type = 'button',
  ...props 
}) => {
  const variants = {
    primary: 'bg-gradient-to-r from-emerald-500 to-teal-600 text-white hover:opacity-90',
    secondary: 'bg-slate-700 text-white hover:bg-slate-600',
    danger: 'bg-gradient-to-r from-rose-500 to-pink-600 text-white hover:opacity-90',
    warning: 'bg-gradient-to-r from-amber-500 to-orange-600 text-white hover:opacity-90',
    ghost: 'bg-transparent text-slate-300 hover:bg-slate-700',
    outline: 'border-2 border-slate-600 text-slate-300 hover:border-emerald-500 hover:text-emerald-400'
  };

  const sizes = {
    xs: 'px-2 py-1 text-xs',
    sm: 'px-3 py-1.5 text-sm',
    md: 'px-4 py-2.5',
    lg: 'px-6 py-3 text-lg'
  };

  return (
    <button
      type={type}
      className={`
        inline-flex items-center justify-center gap-2 font-semibold rounded-xl 
        transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed 
        ${variants[variant]} ${sizes[size]} ${className}
      `}
      disabled={disabled || loading}
      {...props}
    >
      {loading ? (
        <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin" />
      ) : Icon && <Icon size={size === 'sm' || size === 'xs' ? 16 : 20} />}
      {children}
    </button>
  );
};

export default Button;
